
import PromoCodeGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/PromoCodeService/PromoCodeGetDetailResponse";
import UsersPromoCodeResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/PromoCodeService/UsersPromoCodeResponse";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class PagePromocodeHistoryComponent extends Vue {
  isLoading = false;
  promocode: PromoCodeGetDetailResponse = new PromoCodeGetDetailResponse();

  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }

  get promocodeCode(): string {
    return this.promocode.Code || "-";
  }

  get users(): Array<UsersPromoCodeResponse & { RowNumber: number }> {
    return (this.promocode.Users || []).map((item, index) => ({
      ...item,
      RowNumber: index + 1,
    }));
  }

  async created() {
    await this.fetchData();
  }

  async fetchData() {
    if (!this.id) {
      return;
    }

    this.isLoading = true;
    try {
      this.promocode = await this.$api.PromoCodeService.getDetailAsync(this.id);
    } catch (error) {
      this.promocode = new PromoCodeGetDetailResponse();
      this.$notification.error((error || {}).ErrorMessage || error);
    } finally {
      this.isLoading = false;
    }
  }
}
